import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TopBar from '../../common/TopBar';
import './Settings.css';

const PRESET_COLORS = [
  { name: 'Default', value: '#f8f8f8' },
  { name: 'Blue', value: '#e3f2fd' },
  { name: 'Green', value: '#e8f5e9' },
  { name: 'Orange', value: '#fff3e0' },
  { name: 'Pink', value: '#fce4ec' },
  { name: 'Purple', value: '#f3e5f5' }
];

const LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'ko', name: '한국어' },
  { code: 'ja', name: '日本語' },
  { code: 'es', name: 'Español' }
];

export default function Settings() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [selectedColor, setSelectedColor] = useState(
    localStorage.getItem('otpCardColor') || '#f8f8f8'
  );
  const [customColor, setCustomColor] = useState(selectedColor);

  const topHeader = {
    title: t('settings.title'),
    rightIcon: 'closeSvg',
  };

  const handleGoBack = () => {
    navigate('/vtotp/otp-list');
  };

  const handleLanguageChange = (langCode) => {
    setSelectedLanguage(langCode);
    i18n.changeLanguage(langCode);
    window.commonInterface.changeLanguage(langCode);
  };

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    setCustomColor(color);
    localStorage.setItem('otpCardColor', color);
  };

  const handleCustomColorChange = (e) => {
    const color = e.target.value;
    setCustomColor(color);
    setSelectedColor(color);
    localStorage.setItem('otpCardColor', color);
  };

  const isPresetColor = PRESET_COLORS.some(c => c.value === selectedColor);

  return (
    <div className="page-wrapper">
      <TopBar topHeader={topHeader} onRightClick={handleGoBack} />
      <div className="settings-content">
        {/* Language Section */}
        <section className="settings-section">
          <h3>{t('settings.language')}</h3>
          <div className="language-list">
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                className={`language-item ${selectedLanguage === lang.code ? 'selected' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                {lang.name}
              </button>
            ))}
          </div>
        </section>

        {/* Background Color Section */}
        <section className="settings-section">
          <h3>{t('settings.backgroundColor')}</h3>

          <div className="color-subsection">
            <h4>{t('settings.presetColors')}</h4>
            <div className="color-grid">
              {PRESET_COLORS.map((color) => (
                <button
                  key={color.value}
                  className={`color-item ${selectedColor === color.value ? 'selected' : ''}`}
                  style={{ backgroundColor: color.value }}
                  onClick={() => handleColorSelect(color.value)}
                  title={color.name}
                />
              ))}
            </div>
          </div>

          <div className="color-subsection">
            <h4>{t('settings.customColor')}</h4>
            <div className="custom-color-row">
              <input
                type="color"
                value={customColor}
                onChange={handleCustomColorChange}
                className="color-picker"
              />
              <div
                className={`color-preview ${!isPresetColor ? 'selected' : ''}`}
                style={{ backgroundColor: customColor }}
              />
              <span className="color-value">{customColor}</span>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
